import * as React from "react"

function SvgRatingStarCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 50 51"
      {...props}
    >
      <g
        stroke="#E69B19"
        strokeWidth={2.083}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M25 2.035c13.231 0 23.958 10.727 23.958 23.959 0 13.231-10.727 23.958-23.958 23.958-13.231 0-23.958-10.727-23.958-23.958C1.042 12.762 11.769 2.035 25 2.035z" />
        <path d="M26.47 13.354l3.207 7.438h6.24a1.529 1.529 0 011.585 1.475c.017.456-.17.896-.51 1.198l-5.417 4.825 3 6.902a1.633 1.633 0 01-2.327 2.045L25 33.152l-7.25 4.085a1.636 1.636 0 01-2.333-2.045l3.006-6.9-5.417-4.823a1.533 1.533 0 01-.133-2.163 1.533 1.533 0 011.206-.514h6.25l3.21-7.438a1.667 1.667 0 012.932 0z" />
      </g>
    </svg>
  )
}

export default SvgRatingStarCircle
